<template>
    <div class="face-rate">
        <div class="logo">
            <img alt="logo" src="@/assets/icons/logo_mini.svg" class="bad">
        </div>
        <div class="push_rate"></div>
        <div class="main-text">
            <span class="bold">{{translate('QR_smiley_disabled')}}</span>
            <br><br>
            <span v-html='translate(`QR_smiley_disabled_links`, [`<a href="https://air-vote.com">air-vote.com</a>`, `<a href="mailto:team@air-vote.com">team@air-vote.com</a>`])'></span>
            <br><br>
            <span class="bold">{{translate('QR_smiley_disabled_footer')}}</span>
        </div>
        <div class="footer-text">{{translate('powered_by')}}</div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                sendRateClass: false,
                rate_id: this.$route.params.number,
                signInLoading: false,
            }
        },
        methods: {

        }
    }
</script>

<style scoped>

* {
    font-weight: 500;
}
    .bold {
        font-weight: 800;
    }
    .logo {
        margin-top: 1em;
        text-align: center;
        margin-bottom: 15px;
    }

    .push_rate ul li a {
        padding-top: 8px;
        width: 28vw;
        height: 28vw;
        max-width: 100px;
        max-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .push_rate ul li img {
        width: 25vw;
    }
    .face-rate {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        flex: 1 1;
        overflow: auto;
    }
    .main-text {
        text-align: center;
        padding-right: 25px;
        padding-left: 25px;
        white-space: pre-wrap;
        display: flex;
        flex-direction: column;
    }
    .main-text a {
        color: #1976D2;
        text-underline: none;
        outline: none;
        text-decoration: none;
        cursor: pointer;
    }
    .main-text a:hover {
        text-decoration: none;
        color: #1976D2;
    }
    .footer-text {
        margin-bottom: 20px;
        text-align: center;
        white-space: pre-wrap;
        font-size: 10px;
        visibility: hidden;
    }
    @media screen and (max-width: 768px) {
        .face-rate {
            height: auto;
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            transition: all .5s ease-in-out;
        }
    }
</style>